﻿import { useAuthenticationStore } from '@/stores/useAuthenticationStore'
import { useLoadingStore } from '@/stores/useLoadingStore'
import { loginRequest } from '@/utils/msal'
import { storeToRefs } from 'pinia'
import type { RouteLocationNormalized, Router } from 'vue-router'
import { CustomNavigationClient } from './navigationClient'
export function registerGuard(router: Router) {
    router.beforeEach(() => {

        const loadingStore = useLoadingStore()
        loadingStore.startLoading()
    })
    router.afterEach(() => {
        const loadingStore = useLoadingStore()
        loadingStore.stopLoading()
    })
    router.beforeEach(

        async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
            console.debug(`navigating from ${from.path} to ${to.path}`)
            if (!to?.meta?.requiresAuth) return true

            const request = {
                ...loginRequest,
                redirectStartPage: to.fullPath
            }
            const authStore = useAuthenticationStore()
            await authStore.initialize(new CustomNavigationClient(router))
            const { account, isNewUser } = storeToRefs(authStore)
            // logged in
            console.debug('checking if logged in')
            if (account.value) {
                console.debug('logged in')
                if (isNewUser.value && from.name === undefined) {
                    return true

                    //    return { name: 'home' }
                } else {
                    return true
                }
            }
            console.debug('not logged in')
            // not logged in but requires auth
            if (to?.meta?.requiresAuth) {
                try {
                    await authStore.login(request)
                    return true
                } catch (err) {
                    return { path: '/failed' }
                }
            } else {
                return true // <-- Ændring: Tillad navigation, hvis requiresAuth er false
            }
        }
    )
}
